import styled from 'styled-components';

export const CheckMark = styled.div`
    position: absolute;
    z-index: 2;
    left: 6px;
    top: 3px;
`;

export const InnerCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    padding: 10px;
`;
